
import { Component, Vue, Watch } from 'vue-property-decorator'
import Constants from '@/constants'
import axios from 'axios'
import { HeadersVO } from '@/views/biz/admin/vo/DataTablesVO'
import { MstSlideVO } from '@/views/biz/admin/slide/vo/SlideVO'

@Component
export default class Slides extends Vue {
  dialog = false;
  dialogDelete = false;
  editedIndex = -1;

  slides = [] as Array<MstSlideVO>;
  editedItem = {} as MstSlideVO;
  defaultItem = {} as MstSlideVO;

  get getHeaders(): Array<HeadersVO> {
    return [
      {text: '코드', align: 'start', sortable: false, value: 'slNo', width: 70},
      {text: '슬라이드코드', align: 'start', sortable: false, value: 'slType', width: 120},
      {text: '슬라이드구분', align: 'start', sortable: false, value: 'slTypeNm', width: 120},
      {text: '내용', align: 'start', sortable: false, value: 'slContent', width: 200},
      {text: '사용여부', align: 'start', sortable: false, value: 'slYn', width: 100},
      {text: 'URL', align: 'start', sortable: false, value: 'slUrl', width: 300},
      {text: '파라미터', align: 'start', sortable: false, value: 'slParam', width: 80},
      {text: '정렬순서', align: 'end', sortable: false, value: 'slOrd', width: 120},
      {text: '등록일', align: 'start', sortable: false, value: 'regDt', width: 150},
      {text: '수정일', align: 'start', sortable: false, value: 'uptDt', width: 150},
      {text: '수정/삭제', align: 'center', sortable: false, value: 'actions', width: 150},
    ]
  }

  get formTitle() {
    return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
  }

  close () {
    this.dialog = false
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    })
  }

  closeDelete () {
    this.dialogDelete = false
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    })
  }

  deleteItem (item) {
    this.editedIndex = this.slides.indexOf(item)
    this.editedItem = Object.assign({}, item)
    this.dialogDelete = true
  }

  deleteItemConfirm () {
    this.slides.splice(this.editedIndex, 1)
    this.closeDelete()
  }

  editItem (item) {
    this.editedIndex = this.slides.indexOf(item)
    this.editedItem = Object.assign({}, item)
    this.dialog = true
  }

  save () {
    if (this.editedIndex > -1) {
      Object.assign(this.slides[this.editedIndex], this.editedItem)
    } else {
      this.slides.push(this.editedItem)
    }
    this.close()
  }

  @Watch('dialog')
  changeDialog(e) {
    e || this.close();
  }
  @Watch('dialogDelete')
  changeDialogDelete(e) {
    e || this.closeDelete();
  }

  created(): void {
    axios.get('admin/slide/slides').then(r=>{
      this.slides = r.data;
    })
  }

  
}
